import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MaterialCommunityIcons } from '../../utils/icons';
import './SOSScreen.css';

const SOSScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="sos-container">
      <div className="sos-header">
        <button onClick={() => navigate('/')}>
          <MaterialCommunityIcons name="arrow-back" size={24} color="#FF006E" />
        </button>
        <h1>Emergency SOS</h1>
      </div>
      <div className="sos-content">
        <p>Emergency SOS functionality coming soon...</p>
        <button className="sos-button">
          <MaterialCommunityIcons name="warning" size={32} color="white" />
          <span>EMERGENCY SOS</span>
        </button>
      </div>
    </div>
  );
};

export default SOSScreen;

